import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
var _createReducer;
import _Number$parseFloat from "@babel/runtime-corejs2/core-js/number/parse-float";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$entries from "@babel/runtime-corejs2/core-js/object/entries";
import _Number$isNaN from "@babel/runtime-corejs2/core-js/number/is-nan";
import _parseFloat from "@babel/runtime-corejs2/core-js/parse-float";
import { createReducer, createAction } from 'redux-act';
import { createSelector } from 'reselect';
import { createResource } from '@gandi/redux-resource';
import { selectCurrentId } from '@gandi/redux-sharing';
import { selectRaw as selectRawState, selectSharingIdProp } from './utils';
import { resource as infosResource, fetchInfos, selectIsLoaded, selectIsFetching, selectIsFailure, selectIsToRefetch } from './infos';
export { selectIsLoaded, selectIsFetching, selectIsFailure, selectIsToRefetch };
export var fetchPrepaid = fetchInfos;
export var setWarningThreshold = createAction('[billing.prepaid] Set Warning Threshold');
export var setAutomaticCredit = createAction('[billing.prepaid] Set Automatic Credit');
export var setOptimisticPrepaid = createAction('[billing.prepaid] Set Optimistic Prepaid');
export var selectRaw = createSelector([selectRawState], function (raw) {
  return raw.prepaid;
});
var getPrepaid = function getPrepaid(raw, sharingId) {
  return raw[sharingId];
};
export var selectPrepaid = createSelector([selectRaw, selectSharingIdProp], getPrepaid);
export var selectPrepaidForCurrent = createSelector([selectRaw, selectCurrentId], getPrepaid);
var getPrepaidId = function getPrepaidId() {
  var prepaid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return prepaid.id;
};
export var selectPrepaidId = createSelector([selectPrepaid, selectSharingIdProp], getPrepaidId);
export var selectPrepaidIdForCurrent = createSelector([selectPrepaidForCurrent], getPrepaidId);
var getPrepaidIsOptimistic = function getPrepaidIsOptimistic(prepaid) {
  return prepaid ? !prepaid.id : false;
};
export var selectPrepaidIsOptimistic = createSelector([selectPrepaid, selectSharingIdProp], getPrepaidIsOptimistic);
export var selectPrepaidIsOptimisticForCurrent = createSelector([selectPrepaidForCurrent], getPrepaidIsOptimistic);
var getCurrency = function getCurrency() {
  var prepaid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return prepaid.currency;
};
export var selectCurrency = createSelector([selectPrepaid], getCurrency);
export var selectCurrencyForCurrent = createSelector([selectPrepaidForCurrent], getCurrency);
var getWarningThreshold = function getWarningThreshold() {
  var prepaid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return prepaid.warningThreshold;
};
export var selectWarningThreshold = createSelector([selectPrepaid], getWarningThreshold);
export var selectWarningThresholdForCurrent = createSelector([selectPrepaidForCurrent], getWarningThreshold);
var getAutomaticCredit = function getAutomaticCredit() {
  var prepaid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return prepaid.automaticCredit;
};
export var selectAutomaticCredit = createSelector([selectPrepaid], getAutomaticCredit);
export var selectAutomaticCreditForCurrent = createSelector([selectPrepaidForCurrent], getAutomaticCredit);
var getPrepaidAmount = function getPrepaidAmount() {
  var prepaid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return prepaid.amount;
};
export var selectPrepaidAmount = createSelector([selectPrepaid], getPrepaidAmount);
export var selectPrepaidAmountForCurrent = createSelector([selectPrepaidForCurrent], getPrepaidAmount);
var selectIsLoadedForCurrent = function selectIsLoadedForCurrent(state) {
  var sharingId = selectCurrentId(state);
  return selectIsLoaded(state, {
    sharingId: sharingId
  });
};
var getCanChangeCurrency = function getCanChangeCurrency(isLoaded, prepaid) {
  return isLoaded ? !prepaid || prepaid.amount === undefined || prepaid.amount === null || prepaid.amount === 0 : undefined;
};
export var selectCanChangeCurrency = createSelector([selectIsLoaded, selectPrepaid], getCanChangeCurrency);
export var selectCanChangeCurrencyForCurrent = createSelector([selectIsLoadedForCurrent, selectPrepaidForCurrent], getCanChangeCurrency);
var formatPrepaidAPIReturn = function formatPrepaidAPIReturn(_ref) {
  var prepaid = _ref.prepaid;
  if (prepaid) {
    return _objectSpread({
      warningThreshold: prepaid.warning_threshold || null,
      dateCreated: prepaid.date_created,
      dateUpdated: prepaid.date_updated,
      currency: prepaid.currency,
      amount: _Number$parseFloat(prepaid.amount),
      id: prepaid.id
    }, prepaid.automatic_credit && {
      automaticCredit: prepaid.automatic_credit
    });
  }
  return undefined;
};
export var selectIsPrepaidInUse = function selectIsPrepaidInUse(state, _ref2) {
  var sharingId = _ref2.sharingId;
  return !!state.gandiReduxBilling.prepaid[sharingId] && (state.gandiReduxBilling.prepaid[sharingId].dateCreated !== state.gandiReduxBilling.prepaid[sharingId].dateUpdated || state.gandiReduxBilling.prepaid[sharingId].amount !== 0);
};
export var resource = createResource('billing.billing.prepaid');
export var selectIsFetchingLast = function selectIsFetchingLast(state, _ref3) {
  var sharingId = _ref3.sharingId;
  return resource.selectIsFetchingOne(state, sharingId);
};
export var selectIsLoadedLast = function selectIsLoadedLast(state, _ref4) {
  var sharingId = _ref4.sharingId;
  return resource.selectIsLoadedOne(state, sharingId);
};
export var selectIsFailureLast = function selectIsFailureLast(state, _ref5) {
  var sharingId = _ref5.sharingId;
  return resource.selectIsFailureOne(state, sharingId);
};
export var selectIsToRefetchLast = function selectIsToRefetchLast(state, _ref6) {
  var sharingId = _ref6.sharingId;
  return resource.selectIsToRefetchOne(state, sharingId);
};
export var selectIsCreating = function selectIsCreating(state, _ref7) {
  var sharingId = _ref7.sharingId;
  return resource.selectIsCreatingOne(state, sharingId);
};
export var selectIsPatching = function selectIsPatching(state, _ref8) {
  var sharingId = _ref8.sharingId;
  return resource.selectIsPatchingOne(state, sharingId);
};
export var selectIsDeleting = function selectIsDeleting(state, _ref9) {
  var sharingId = _ref9.sharingId;
  return resource.selectIsDeletingOne(state, sharingId);
};

/**
 * Fetch the latest prepaid for a given sharing_id.
 * Most of the times, use `fetchPrepaid` or `fetchBillingInfos`
 * to acquire both `prepaid` and other billing information.
 * `fetchLastPrepaid` is only useful to retrieve the prepaid
 * as fast as possible, without the grid info, which is time-consuming to
 * retrieve.
 */
export var fetchLastPrepaid = function fetchLastPrepaid(sharingId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    sharingId: undefined,
    params: undefined
  };
  return function (dispatch) {
    return dispatch(resource.fetchOne('/billing/prepaids', _objectSpread(_objectSpread({}, options), {}, {
      sharingId: sharingId,
      label: sharingId,
      params: _objectSpread({
        sharing_id: sharingId,
        per_page: 1
      }, options.params || {}),
      on200: function on200(response) {
        return response;
      },
      not200: function not200(response) {
        return _Promise.reject(response);
      }
    })));
  };
};

/**
 * Updating a Prepaid has only one use-case at the moment:
 * - unsetting a Prepaid's warningThreshold.
 * - setting a new value for the Prepaid's warningThreshold.
 */

export var patchPrepaid = function patchPrepaid() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    var currentId = selectCurrentId(getState());
    var sharingId = options.sharingId || currentId;
    var floatifyParam = function floatifyParam(param) {
      if (_typeof(param) === 'object' && param !== null) {
        return Object.fromEntries(_Object$entries(param).map(function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
            k = _ref11[0],
            v = _ref11[1];
          return [k, floatifyParam(v)];
        }));
      }
      return _Number$isNaN(_parseFloat(param)) ? null : _parseFloat(param);
    };

    // PATCH'ing the Prepaid with a `warning_threshold` value as `null` unsets the threshold.
    // PATCH'ing the Prepaid with a `automatic_credit` value as `null` unsets it, but mycard_id remains.
    // eslint-disable-next-line no-nested-ternary
    var warningThreshold = params.warningThreshold !== undefined ? floatifyParam(params.warningThreshold) : undefined;
    var automaticCredit = params.automaticCredit !== undefined ? floatifyParam(params.automaticCredit) : undefined;
    var optimistic = params.optimistic || false;
    var body = function () {
      if (warningThreshold !== undefined) {
        return {
          warning_threshold: warningThreshold
        };
      }
      if (automaticCredit !== undefined) {
        return {
          automatic_credit: automaticCredit
        };
      }
      return {};
    }();
    if (!sharingId) {
      return _Promise.reject(new Error('[billing.prepaid] `patchPrepaid` called without `sharingId` param' + ' nor `prepaid` object in the state.'));
    }
    var previousWarningThreshold = selectWarningThreshold(getState(), {
      sharingId: sharingId
    });
    var previousAutomaticCredit = selectAutomaticCredit(getState(), {
      sharingId: sharingId
    });
    if (optimistic && warningThreshold !== undefined) {
      dispatch(setWarningThreshold({
        warningThreshold: warningThreshold,
        sharingId: sharingId
      }));
    }
    if (optimistic && automaticCredit !== undefined) {
      var automaticCreditObject = automaticCredit === null ?
      // eslint-disable-next-line camelcase
      {
        mycard_id: previousAutomaticCredit === null || previousAutomaticCredit === void 0 ? void 0 : previousAutomaticCredit.mycard_id
      } : _objectSpread(_objectSpread({}, automaticCredit), {}, {
        // eslint-disable-next-line camelcase
        mycard_id: previousAutomaticCredit === null || previousAutomaticCredit === void 0 ? void 0 : previousAutomaticCredit.mycard_id
      });
      dispatch(setAutomaticCredit({
        automaticCredit: automaticCreditObject,
        sharingId: sharingId
      }));
    }
    return dispatch(resource.patchOne("/billing/prepaids/".concat(sharingId), body, _objectSpread(_objectSpread({}, options), {}, {
      params: _objectSpread({
        sharing_id: sharingId
      }, options.params || {}),
      label: sharingId,
      on200: function on200(response) {
        return response;
      },
      not200: function not200(response) {
        return _Promise.reject(response);
      }
    }))).catch(function (err) {
      if (optimistic && warningThreshold !== undefined) {
        dispatch(setWarningThreshold({
          warningThreshold: previousWarningThreshold,
          sharingId: sharingId
        }));
        if (optimistic && automaticCredit !== undefined) {
          dispatch(setAutomaticCredit({
            automaticCredit: previousAutomaticCredit,
            sharingId: sharingId
          }));
        }
      }
      throw err;
    });
  };
};
export var createPrepaid = function createPrepaid(params) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    var currentId = selectCurrentId(getState());
    var sharingId = options.sharingId || currentId;
    if (typeof sharingId !== 'string') {
      return _Promise.reject(new Error('[billing.prepaid] `createPrepaid` called without `sharingId` option' + ' nor @gandi/redux-sharing dep/state.'));
    }
    var currency = params.currency;
    var optimistic = params.optimistic || false;
    var body = {
      currency: currency
    };
    return dispatch(resource.createOne('/billing/prepaids', body, _objectSpread(_objectSpread({}, options), {}, {
      params: _objectSpread(_objectSpread({}, options.params), {}, {
        sharing_id: sharingId
      }),
      label: sharingId,
      on201: function on201(response) {
        /*
         *  Prepaid creation was successful, we update the store with an optimistic
         *  version of the prepaid object, so navigation feels natural.
         *  An up-to-date version of the prepaid object
         *  will be fetched on every upcoming important prepaid action.
         */
        if (optimistic) dispatch(setOptimisticPrepaid(_objectSpread(_objectSpread({}, body), {}, {
          sharingId: sharingId
        })));
        return response;
      },
      not201: function not201(response) {
        return _Promise.reject(response);
      }
    })));
    /*
    .then(() => {
    dispatch(infosResource.setIsToRefetchOne({ label: sharingId }));
    })
    */
  };
};

export var deletePrepaid = function deletePrepaid() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState) {
    var currentId = selectCurrentId(getState());
    var sharingId = options.sharingId || currentId;
    if (typeof sharingId !== 'string') {
      return _Promise.reject(new Error('[billing.prepaid] `deletePrepaid` called without `sharingId` option' + ' nor @gandi/redux-sharing dep/state.'));
    }
    return dispatch(resource.deleteOne("/billing/prepaids/".concat(sharingId), _objectSpread(_objectSpread({}, options), {}, {
      params: _objectSpread(_objectSpread({}, options.params), {}, {
        sharing_id: sharingId
      }),
      label: sharingId,
      on200: function on200(response) {
        return response;
      },
      not200: function not200(response) {
        return _Promise.reject(response);
      }
    })));
    /*
    .then(() => {
    dispatch(infosResource.setIsToRefetchOne({ label: sharingId }));
    })
    */
  };
};

export var replacePrepaid = function replacePrepaid() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    sharingId: undefined,
    params: undefined
  };
  return function (dispatch, getState) {
    var currency = params.currency;
    var currentId = selectCurrentId(getState());
    var sharingId = options.sharingId || currentId;
    if (typeof sharingId !== 'string') {
      return _Promise.reject(new Error('[billing.prepaid] `replacePrepaid` called without `sharingId` option' + ' nor @gandi/redux-sharing dep/state.'));
    }
    var prepaid = selectPrepaid(getState(), {
      sharingId: sharingId
    });
    var promise = _Promise.resolve();
    if (prepaid) {
      promise = dispatch(deletePrepaid(options));
    }
    return promise.then(function () {
      return dispatch(createPrepaid({
        currency: currency
      }, options));
    }).then(function () {
      return dispatch(fetchPrepaid(options));
    });
  };
};
var reducer = createReducer((_createReducer = {}, _defineProperty(_createReducer, resource.fetchOne.success.getType(), function (state, _ref12) {
  var data = _ref12.response.data,
    sharingId = _ref12.label;
  if (Array.isArray(data) && data[0]) {
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, sharingId, formatPrepaidAPIReturn({
      prepaid: data[0]
    })));
  }
  return state;
}), _defineProperty(_createReducer, infosResource.fetchOne.success.getType(), function (state, _ref13) {
  var data = _ref13.response.data,
    sharingId = _ref13.label;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, sharingId, state[sharingId] ? _objectSpread(_objectSpread({}, state[sharingId] || {}), formatPrepaidAPIReturn(data)) : formatPrepaidAPIReturn(data)));
}), _defineProperty(_createReducer, setOptimisticPrepaid, function (state, _ref14) {
  var currency = _ref14.currency,
    sharingId = _ref14.sharingId;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, sharingId, {
    currency: currency,
    amount: 0
  }));
}), _defineProperty(_createReducer, setWarningThreshold, function (state, _ref15) {
  var warningThreshold = _ref15.warningThreshold,
    sharingId = _ref15.sharingId;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, sharingId, _objectSpread(_objectSpread({}, state[sharingId] || {}), {}, {
    warningThreshold: warningThreshold
  })));
}), _defineProperty(_createReducer, setAutomaticCredit, function (state, _ref16) {
  var automaticCredit = _ref16.automaticCredit,
    sharingId = _ref16.sharingId;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, sharingId, _objectSpread(_objectSpread({}, state[sharingId] || {}), {}, {
    automaticCredit: automaticCredit
  })));
}), _createReducer), {});
export default reducer;